import { t } from "@lingui/core/macro"
import { ArrowRightLeft, Info, Monitor } from "lucide-react"
import { Card, CardContent, CardHeader } from "~/components/ui/card"
import { Typography } from "~/components/ui/typography"

const SCREEN_GUARD_BREAKPOINT = 1280

export function ScreenGuard() {
  return (
    <div className="flex h-dvh items-center justify-center">
      <Card className="max-w-md border shadow-md">
        <CardHeader className="space-y-0 space-x-0">
          <div className="w-full flex flex-col gap-1 items-center">
            <div className="flex items-center gap-2">
              <Info className="text-blue-500" />
              <Typography variant="h3" as="h1" fontWeight="semibold">
                {t`Screen Size Alert`}
              </Typography>
            </div>
            <div className="mx-auto flex flex-col items-center">
              <Typography variant="muted">
                {t`Your screen size is smaller than the required width.`}
              </Typography>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-x-0 space-y-0">
          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-center gap-4">
              <Monitor className="size-6 text-muted-foreground" />
              <ArrowRightLeft className="size-6 text-muted-foreground" />
              <Typography variant="h4">
                {t`${SCREEN_GUARD_BREAKPOINT} pixels.`}
              </Typography>
            </div>
            <Typography className="text-center">
              {t`To ensure the best experience, use a device with a screen width over ${SCREEN_GUARD_BREAKPOINT} pixels.`}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
